/* ==========================================================================
   SELLAMAX — product.js
   Selector de variantes, precio e inventario dinámicos, galería y
   sincronización con la barra fija móvil.
   ========================================================================== */

(function () {
  'use strict';

  var Theme = window.SellamaxTheme || {};
  var Product = {};
  window.SellamaxProduct = Product;

  function initProduct(root) {
    var dataNode = root.querySelector('[data-product-json]');
    if (!dataNode) return;

    var product;
    try {
      product = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    var variantInputs = root.querySelectorAll('[data-variant-input]');
    var idInput = root.querySelector('[data-variant-id]');
    var priceNode = root.querySelector('[data-variant-price]');
    var compareNode = root.querySelector('[data-variant-compare]');
    var unitNode = root.querySelector('[data-variant-unit]');
    var stockNode = root.querySelector('[data-variant-stock]');
    var addButton = root.querySelector('[data-add-button]');
    var buyNowButton = root.querySelector('[data-buy-now]');
    var quantityInput = root.querySelector('[data-quantity-input]');

    var savingsNode = root.querySelector('[data-variant-savings]');
    var promoNode = root.querySelector('[data-promo-vigencia]');
    var shipNode = root.querySelector('[data-shipping-note]');
    var inventoryNode = root.querySelector('[data-variant-inventory]');
    var soldOutOnly = root.querySelectorAll('[data-sold-out-only]');

    var stickyName = document.querySelector('[data-sticky-name]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickySavings = document.querySelector('[data-sticky-savings]');

    /**
     * Presentaciones detectadas por los kilogramos del título de la variante.
     * De aquí sale el ahorro, con la misma fórmula que usa el comparador:
     *   referencia = precio_chica × (kg_grande ÷ kg_chica)
     *   ahorro     = referencia − precio_grande
     */
    var packs = product.variants
      .map(function (v) {
        return { variant: v, kg: variantWeight(v) };
      })
      .filter(function (p) {
        return p.kg > 0;
      })
      .sort(function (a, b) {
        return a.kg - b.kg;
      });

    function savingsFor(variant) {
      if (packs.length < 2) return null;

      var smallest = packs[0];
      var current = packs.filter(function (p) {
        return p.variant.id === variant.id;
      })[0];

      if (!current || current.variant.id === smallest.variant.id) return null;

      var ratio = current.kg / smallest.kg;
      var reference = smallest.variant.price * ratio;
      var amount = reference - current.variant.price;
      if (amount <= 0) return null;

      var pct = Math.round((amount / reference) * 100);
      if (pct <= 0) return null;

      return { amount: amount, pct: pct, reference: reference };
    }

    function currentVariant() {
      var checked = Array.prototype.filter.call(variantInputs, function (input) {
        return input.checked;
      })[0];
      var id = checked ? Number(checked.value) : Number(idInput && idInput.value);
      return product.variants.filter(function (variant) {
        return variant.id === id;
      })[0] || product.variants[0];
    }

    function update(variant, options) {
      if (!variant) return;
      var silent = options && options.silent;

      if (idInput) idInput.value = variant.id;

      if (priceNode) priceNode.textContent = Theme.formatMoney(variant.price);

      if (compareNode) {
        var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareNode.hidden = !hasCompare;
        if (hasCompare) compareNode.textContent = Theme.formatMoney(variant.compare_at_price);
      }

      if (unitNode) {
        var weight = variantWeight(variant);
        if (weight) {
          unitNode.textContent = Theme.formatMoney(Math.round(variant.price / weight)) + ' por kg';
          unitNode.hidden = false;
        } else {
          unitNode.hidden = true;
        }
      }

      // El rendimiento en m² no se publica: no hay ficha técnica del proveedor
      // que lo respalde. El texto orientativo vive en el Liquid.

      if (stockNode) {
        stockNode.className = 'stock';
        if (!variant.available) {
          stockNode.classList.add('stock--out');
          stockNode.textContent = 'Sin existencia por el momento';
        } else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
          stockNode.classList.add('stock--low');
          stockNode.textContent = 'Últimas ' + variant.inventory_quantity + ' piezas disponibles';
        } else {
          stockNode.classList.add('stock--in');
          stockNode.textContent = 'Disponible';
        }
      }

      // Ahorro de esta presentación frente a comprar varias de la chica
      var saving = savingsFor(variant);
      if (savingsNode) {
        if (saving) {
          savingsNode.textContent =
            'Ahorras ' + Theme.formatMoney(saving.amount) + ' · ' + saving.pct + '% de ahorro';
          savingsNode.hidden = false;
        } else {
          savingsNode.textContent = '';
          savingsNode.hidden = true;
        }
      }

      if (inventoryNode) inventoryNode.innerHTML = inventoryMarkup(variant);

      // El envío gratis depende del umbral real de la zona de envío
      if (shipNode) {
        var cfgS = Theme.shipping || {};
        var alcanza = !cfgS.threshold || variant.price >= cfgS.threshold;
        shipNode.className = alcanza ? 'shipping-note' : 'shipping-note shipping-note--paid';
        shipNode.dataset.shippingState = alcanza ? 'free' : 'paid';
        shipNode.innerHTML = shippingMarkup(variant);
      }

      // El aviso de precio de lanzamiento sólo aplica a las variantes listadas
      if (promoNode) {
        var enPromo = (promoNode.dataset.promoVariants || '')
          .split(',')
          .filter(Boolean)
          .indexOf(String(variant.id)) !== -1;
        promoNode.hidden = !enPromo;
      }

      Array.prototype.forEach.call(soldOutOnly, function (node) {
        node.hidden = variant.available;
      });

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Agregar al carrito' : 'Agotado temporalmente';
        addButton.dataset.selectedVariant = variant.id;
      }

      if (buyNowButton) buyNowButton.hidden = !variant.available;

      if (stickyName) stickyName.textContent = product.title + ' · ' + variant.title;
      if (stickyPrice) stickyPrice.textContent = Theme.formatMoney(variant.price);
      if (stickySavings) {
        if (saving) {
          stickySavings.textContent = 'Ahorras ' + Theme.formatMoney(saving.amount);
          stickySavings.hidden = false;
        } else {
          stickySavings.hidden = true;
        }
      }

      // Mantiene la URL compartible sin recargar la página.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      showVariantImage(variant);

      if (!silent) {
        Theme.track('variant_select', {
          variant_id: variant.id,
          variant_title: variant.title,
          price: variant.price / 100
        });
      }
    }

    /**
     * Reproduce free-shipping.liquid: no se anuncia envío gratis en una
     * variante que no alcanza el umbral configurado en Shopify.
     */
    function shippingMarkup(variant) {
      var cfg = Theme.shipping || {};
      if (!cfg.enabled) return '';

      var icono =
        '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M2 6.5h11v10H2z"/><path d="M13 10h4l3 3v3.5h-7z"/>' +
        '<circle cx="6.5" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>';

      var umbral = cfg.threshold || 0;

      if (!umbral || variant.price >= umbral) {
        return icono + ' ' + (cfg.note || 'Recíbelo con envío gratis.');
      }

      var falta = umbral - variant.price;
      return (
        icono +
        ' <span>Envío ' + Theme.formatMoney(cfg.rate || 0) + '. ' +
        '<strong>Te faltan ' + Theme.formatMoney(falta) + ' para el envío gratis.</strong></span>'
      );
    }

    /**
     * Reproduce en el cliente la lógica de inventory-status.liquid para que el
     * mensaje siga siendo correcto al cambiar de presentación sin recargar.
     */
    function inventoryMarkup(variant) {
      var cfg = Theme.inventory || {};
      var low = cfg.low || 20;
      var limited = cfg.limited || 100;
      var tracked = !!variant.inventory_management;
      var qty = tracked ? variant.inventory_quantity : null;

      if (!tracked) {
        var fb = (cfg.fallback || {})[String(variant.id)];
        if (fb) qty = Number(fb);
      }

      var cls = 'inventory__state inventory__state--ok';
      var text = 'Disponible';

      if (!variant.available) {
        cls = 'inventory__state inventory__state--out';
        text = 'Agotado temporalmente';
      } else if (cfg.show && qty !== null && qty > 0) {
        if (qty > limited) {
          text = 'Lote disponible: ' + qty + ' unidades.';
        } else if (qty > low) {
          cls = 'inventory__state inventory__state--limited';
          text = 'Inventario limitado: quedan ' + qty + '.';
        } else {
          cls = 'inventory__state inventory__state--low';
          text = 'Quedan solamente ' + qty + ' unidades.';
        }
      }

      return '<p class="inventory"><span class="' + cls + '">' + text + '</span></p>';
    }

    /**
     * Kilogramos TOTALES de la variante. Misma lógica que variant-kg.liquid.
     *
     * Formatos que entiende:
     *   "1 bote de 1 kg"                        → 1
     *   "2 botes de 1 kg"                       → 2   (cantidad × peso)
     *   "1 bote de 5 kg — para azoteas grandes" → 5
     *   "5 Kilogramos"                          → 5
     *
     * El paso de la cantidad es lo que evita que "2 botes de 1 kg" se lea
     * como 1 kg y el precio por kilo salga igual al precio total.
     */
    function variantWeight(variant) {
      // Se descarta la orientación de uso que va tras el guion largo
      var texto = String(variant.title).split('—')[0];
      var t = texto
        .toLowerCase()
        .replace(/kilogramos|kilogramo|kilos|kilo/g, 'kg');

      // "2 botes de 1 kg": cantidad antes del "de", peso después
      var compuesto = t.match(/(\d+(?:[.,]\d+)?)\s*[^\d]*\s+de\s+(\d+(?:[.,]\d+)?)\s*kg/);
      if (compuesto) {
        var cantidad = parseFloat(compuesto[1].replace(',', '.'));
        var unitario = parseFloat(compuesto[2].replace(',', '.'));
        if (cantidad > 0 && unitario > 0) return cantidad * unitario;
      }

      // "1 kg" / "5 Kilogramos"
      var simple = t.match(/([\d.,]+)\s*kg\b/);
      if (simple) return parseFloat(simple[1].replace(',', '.'));

      if (variant.weight && variant.weight_unit === 'kg') return variant.weight;
      if (variant.weight && variant.weight_unit === 'g') return variant.weight / 1000;
      return null;
    }

    function showVariantImage(variant) {
      if (!variant.featured_image) return;
      var thumb = root.querySelector(
        '.product-gallery__thumb[data-image-id="' + variant.featured_image.id + '"]'
      );
      if (thumb) thumb.click();
    }

    Array.prototype.forEach.call(variantInputs, function (input) {
      input.addEventListener('change', function () {
        update(currentVariant());
      });
    });

    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        var min = Number(quantityInput.min || 1);
        if (Number(quantityInput.value) < min || isNaN(Number(quantityInput.value))) {
          quantityInput.value = min;
        }
      });
    }

    /**
     * Punto de entrada usado por la calculadora para transferir su resultado.
     */
    Product.applySelection = function (variantId, quantity) {
      var input = root.querySelector('[data-variant-input][value="' + variantId + '"]');
      if (input) {
        input.checked = true;
      } else if (idInput) {
        idInput.value = variantId;
      }
      if (quantityInput && quantity) quantityInput.value = quantity;
      update(currentVariant(), { silent: true });
      return true;
    };

    // Estado inicial desde ?variant= o desde la variante seleccionada.
    var params = new URLSearchParams(window.location.search);
    var initialId = Number(params.get('variant'));
    if (initialId) {
      var initial = root.querySelector('[data-variant-input][value="' + initialId + '"]');
      if (initial) initial.checked = true;
    }

    update(currentVariant(), { silent: true });

    Theme.track('view_item', {
      product_id: product.id,
      product_title: product.title,
      variant_id: currentVariant().id
    });
  }

  /**
   * Cuenta regresiva hacia una fecha real. No se reinicia nunca: al vencer,
   * oculta el aviso completo en lugar de volver a empezar.
   */
  function initPromoCountdown() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-promo-vigencia]'),
      function (box) {
        var out = box.querySelector('[data-promo-countdown]');
        var fin = box.dataset.promoEnd;
        if (!out || !fin) return;

        var limite = new Date(fin).getTime();
        if (isNaN(limite)) return;

        function pintar() {
          var restante = limite - Date.now();
          if (restante <= 0) {
            // La promoción terminó: el bloque deja de existir
            box.hidden = true;
            return;
          }

          var dias = Math.floor(restante / 86400000);
          var horas = Math.floor((restante % 86400000) / 3600000);
          var mins = Math.floor((restante % 3600000) / 60000);

          out.innerHTML =
            '<span class="visually-hidden">Tiempo restante de la promoción</span>' +
            unidad(dias, 'días') + unidad(horas, 'hrs') + unidad(mins, 'min');
        }

        function unidad(valor, etiqueta) {
          return (
            '<span class="promo-unit">' +
            '<b class="promo-unit__num">' + valor + '</b>' +
            '<small class="promo-unit__lbl">' + etiqueta + '</small>' +
            '</span>'
          );
        }

        pintar();
        // Basta con revisar cada minuto: la unidad más chica son horas
        window.setInterval(pintar, 30000);
      }
    );
  }

  function initGallery(gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('.product-gallery__thumb');
    if (!main || !thumbs.length) return;

    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        Array.prototype.forEach.call(thumbs, function (item) {
          item.setAttribute('aria-current', 'false');
        });
        thumb.setAttribute('aria-current', 'true');

        var image = main.querySelector('img');
        if (!image) return;
        image.src = thumb.dataset.imageSrc;
        image.srcset = thumb.dataset.imageSrcset || '';
        image.alt = thumb.dataset.imageAlt || '';
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-product-root]'), function (root) {
      if (root.dataset.productReady === 'true') return;
      root.dataset.productReady = 'true';
      initProduct(root);
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-product-gallery]'), initGallery);
    initPromoCountdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
